<template>
  <v-dialog
      :value="dialog"
      @input="dialog = $event"
      max-width="1500"
  >
    <v-card
        outlined
        style="overflow-y: hidden"
    >
      <v-card-title>
        <v-row class="gy-3">
          <v-col><h4>출석 내역</h4></v-col>
          <v-col class="justify-end">
            <v-btn  class="btn primary" small @click="sendAttendanceSheet(true)">출석증</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text >
        <v-row>
          <v-col><v-text-field dense label="Assign Count"    readonly v-model="assignCount"></v-text-field></v-col>
          <v-col><v-text-field dense label="Attended Count"  readonly v-model="countAttended"></v-text-field></v-col>
          <v-col><v-text-field dense label="Postpone Count"  readonly v-model="countPostponed"></v-text-field></v-col>
        </v-row>

        <GridAttend class="agGrid"
                    :attendList="attendList"
                    :column-defines="attendColumnDefs"

                    :is-show-button="false"
                    :is-dialog="true"

                    @onFirstDataRendered="onFirstDataRendered"
                    @onGridReady="onGridReadyAttend"
        />
      </v-card-text>

      <v-card-actions>
        <v-row justify="end">
          <v-col cols="3" sm="3" >
            <v-btn color="blue darken-4"  block small dark @click="$emit('hideDialog')">닫기</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from "vuex";
import apiPdf from "@/api/modules/api-pdf";
import apiManager from "@/api/modules/api-manager";
import GridAttend from "@/components/Grid/grid-attend.vue";
import apiAttend from "@/api/modules/api-attend";

export default {
  name: 'DialogAttend',
  components: {GridAttend},
  props: {
    value: {type: Boolean, required: true},
    selectedAssign: {type: Object},
    attendColumnDefs: {type: Array}
  },
  data(){
    return {
      listLoading: true,
      searchQuery: {
        originAuth: 'EN9DOOR_STUDENT',
        page: 0,
        size: 5,
        assignStatus: null,
        sort: 'createdAt,desc',
        direction: 'DESC'
      },
      attendList: [],

      today: '',

      gridApi: {},
      gridColumnApi: {},
      gridOptions: {},
      gridAttend: {
        defaultColDef: {
          sortable: true,
          filter: true,
          resizable: true
        },
        gridOptions: {
          animateRows: false,
        },
        columnDefs: [
          {flex: 1.2, headerName: '수업일자', colId: 'attendDate', field: 'attendDate'},
          {flex: 1,   headerName: 'Status', colId: 'attendStatus', field: 'attendStatus', cellRenderer: "cellRendererAttendStatus",},
          {flex: 1.2, headerName: '수업연기', colId: 'btnPostpone', field: 'btnPostpone', cellRendererFramework: "btnRendererPostpone"},
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['app','user','isOwner','isManager']),
    dialog: {
      get() {return this.value},
      set(value) {this.$emit('input', value)},
    },
    assignCount() {
      return this.selectedAssign.assignCount ? this.selectedAssign.assignCount : 0
    },
    countAttended() {
      let postponedCount = this.attendList
          .filter(a => a.attendStatus === 'POSTPONE')
          .length
       postponedCount = postponedCount > 5 ? postponedCount - 5 : 0

      return this.attendList.length > 0
        ? this.attendList.filter(a => a.attendStatus === 'ATTEND').length + postponedCount
        : 0
    },
    countPostponed() {
      let postponedCount = this.attendList
          .filter(a => a.attendStatus === 'POSTPONE')
          .length
      postponedCount = postponedCount > 5 ? postponedCount - 5 : 0

      return postponedCount
    }
  },
  created() { },
  mounted() {
    if (this.selectedAssign.assignId) {
      this.getAttendList()
    }
  },
  destroyed() {},
  methods: {
    getAttendList() {
      this.listLoading = true;

      this.searchQuery.assignId = this.selectedAssign.assignId;
      apiAttend.getAttendList(this.searchQuery)
        .then(attendList => {
          let  minusDays = this.isManager ? 50 : 20
          return this.$addScheduledDates(this.selectedAssign, attendList, minusDays)
        })
        .then(res => res.sort((a, b) => (new Date(b.attendDate) - new Date(a.attendDate))))
        .then(res => {
          this.attendList = res
          this.listLoading = false
        })
        .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    onFirstDataRendered(){
      let index = this.attendList.findIndex(v => v.attendDate === this.$formatDate(new Date(), 'YYYY-MM-DD'))
      this.gridOptions.api.ensureIndexVisible(index + 3)
      this.gridOptions.api.getRowNode(index).setSelected(true)
    },
    onClickGridAttendRow(params) {
      let row = params.data
      switch (params.colDef.headerName) {
        case "수업연기": this.postponeToday(row); break;
      }
    },
    onGridReadyAttend(params, gridOptions){
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridOptions = gridOptions
    },
    // onFirstDataRenderedAttend(params){ },
    sendAttendanceSheet(isFake){
      apiPdf.getAttendSheetPopup(this.selectedAssign.assignId)
          .then(() => this.$dialog.notify.success('출석확인증 이메일로 발송되었습니다.', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
  },

}
</script>
